import { render, staticRenderFns } from "./china.vue?vue&type=template&id=119455d4&scoped=true"
import script from "./china.vue?vue&type=script&lang=js"
export * from "./china.vue?vue&type=script&lang=js"
import style0 from "./china.vue?vue&type=style&index=0&id=119455d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119455d4",
  null
  
)

export default component.exports